import axios from 'axios'
import config from '../../utils/config'

const url = config.testUrl

const getPropertyTypes = async ({ paramsSlug, page }) => {
	const response = await axios.get(
		`${url}/reach/${paramsSlug}?pageNumber=${page}`
	)

	return response.data.data
}

const getPropertyDetails = async (id) => {
	const response = await axios.get(`${url}/reach/single-property/${id}`)

	return response.data.data
}

const getPropertyLands = async () => {
	const response = await axios.get(`${url}/reach/lands`)

	return response.data.data
}

const getPropertyHouses = async () => {
	const response = await axios.get(`${url}/reach/houses`)

	return response.data.data
}

const propertyService = {
	getPropertyTypes,
	getPropertyDetails,
	getPropertyHouses,
	getPropertyLands,
}

export default propertyService
